import { useMemo, useState } from 'react';

import { ColumnDef, SortingState } from '@tanstack/react-table';

import { StratRowType, stratsColumnOrder, stratsColumnsConfig } from './startifications.config';
import { DataDisplayTable } from '../../../ui-kit';

import type { StratCardContentProps } from './StratCard';

const commonColumns: ColumnDef<StratRowType>[] = stratsColumnOrder.map((field) => {
  const config = stratsColumnsConfig[field];
  return {
    header: config.header,
    accessorKey: field,
    cell: (cellContext) => config.display(cellContext.getValue() as number | null),
    meta: {
      alignment: 'left',
      numeric: true,
    },
    enableSorting: true,
    enableMultiSort: false,
  };
});

export function StratTable(props: StratCardContentProps) {
  const [sorting, setSorting] = useState<SortingState>([]);

  if (!props.config) return <div>NO CONFIG</div>;

  const config = props.config;

  const columns: ColumnDef<StratRowType>[] = useMemo(() => {
    return [
      {
        accessorKey: 'key',
        header: config.label,
        cell: (cellContext) => cellContext.getValue() as string,
        meta: {
          alignment: 'left',
          numeric: true,
        },
        enableSorting: true,
        enableMultiSort: false,
      },
      ...commonColumns,
    ];
  }, [config]);

  const onSortingChanged = (newSorting: SortingState) => {
    setSorting(newSorting);
  };

  return (
    <DataDisplayTable
      // @ts-ignore TS doesn't like the fact that we're omitting the listing column
      data={props.data}
      // @ts-ignore
      columns={columns}
      noDataMessage="NO DATA"
      // @ts-ignore
      sorting={{ state: sorting, onSortingChanged }}
    />
  );
}
